import { render } from "./bugBounty.vue?vue&type=template&id=ebcdd322"
import script from "./bugBounty.vue?vue&type=script&lang=js"
export * from "./bugBounty.vue?vue&type=script&lang=js"

import "./bugBounty.vue?vue&type=style&index=0&id=ebcdd322&lang=scss"
script.render = render

export default script